// src/services/forms/povici.js

export const PoviciColumns = [
  { name: "brojNalog", label: "Број на налог", field: "brojNalog", align: "left" },
  { name: "datum", label: "Датум", field: "datum", align: "left" },
  // { name: "brojNalog", label: "Број на налог", field: "brojNalog", align: "center" },
  { name: "klient", label: "Клиент", field: "klient", align: "center" },
  { name: "firma", label: "Фирма", field: "firmaIme", align: "center" },
  { name: "vraboten", label: "Вработен", field: "vrabotenIme", align: "center" },
  { name: "opis", label: "Опис", field: "opis", align: "center" },
  { name: "status", label: "Статус", field: "status", align: "center" },
  { name: "akcii", label: "Акции", field: "id", align: "center" }
];
